import { createContext, useContext } from 'react';
import DynamicTextDTO from '../../interfaces/dto/dynamicTextDTO';
import type { SanityList } from '../../interfaces/dto/swapCreditModalContent';

interface DefaultValueProps {
  dynamicText: DynamicTextDTO | undefined;
  swapCreditModalContent: SanityList;
}

const defaultValue: DefaultValueProps = { dynamicText: undefined, swapCreditModalContent: [] };

export const DynamicTextContext = createContext(defaultValue);

export const useDynamicTextContext = () => {
  const context = useContext(DynamicTextContext);
  if (!context) {
    throw new Error('You must use the DynamicText Provider in order to consume this context.');
  }
  return context;
};
